import React, { useEffect } from 'react';
import configurationTags from './AssessmentConfigurationTags.json';
import Dropdown from '../../../../../Global/Dropdown';
import { findSelectedAssessmentTagFromSavedTags } from '.';
import Banners from '../../../blocks/Banners';
/**
 * Renders a component for selecting assessment tags.
 *
 * @param {Object} props - The component props.
 * @param {Function} props.onTagChange - The function to be called when the selected tag changes.
 * @param {Array} props.savedAssessmentTags - The saved assessment tags from database / current state.
 * @param {Number} props.districtId - The district ID.
 * @returns {JSX.Element} The rendered component.
 */
export default function SelectAssessmentTags({ onTagChange, savedAssessmentTags, districtId }) {

  useEffect(() => {
    // if the school has never had an assessment tag saved, we will use the first tag in the list as the default
    // update the state so that it will be saved if they change any settings without changing this one.
    const initialSavedAssessmentTags = findSelectedAssessmentTagFromSavedTags(savedAssessmentTags)
    if(!initialSavedAssessmentTags){
      const selectedTagObject = configurationTags[0];
      onTagChange(selectedTagObject);
    }
  }, []);

  const updateSetting = (e) => {
    if (currentSelectedTag && currentSelectedTag === e.value) {
      return;
    }
    const newValue = e.value === 'none' ? null : e.value;
    const selectedTagObject = newValue ? configurationTags.find(option => option.value === newValue) : null;
    onTagChange(selectedTagObject);
  };

  const currentSelectedTag = findSelectedAssessmentTagFromSavedTags(savedAssessmentTags) || configurationTags[0].value
  const currentSelectedTagObject = configurationTags.find(option => option.value === currentSelectedTag)

  const filteredTags = configurationTags.filter(tag => !tag.appliesToDistrictId || tag.appliesToDistrictId.includes(districtId));

  return (
    <div>
      {savedAssessmentTags && !currentSelectedTagObject && <Banners type="error">Please select an assessment configuration below.</Banners>}
      <div className='config-page-sub-title'>Assessment Configuration</div>
      <Dropdown
        options={filteredTags}
        value={currentSelectedTagObject}
        onChange={(e) => updateSetting(e)}
        isDisabled={false}
      />
    </div>
  );
}
